import { apiSlice } from "../Slices/apiSlice";

export const cartService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllCartItems: builder.query({
          query: (cartId) => `/orderHead-management/managed-orderHead/${cartId}`,
          providesTags: ['cart']
        }),
    
        getCartQuantity: builder.query({
          query: (cartId) => `/orderHead-management/managed-orderHead/get-cart/basic-details/${cartId}`,
          providesTags: ['cart']
        }),
    
        getCartIdforUser: builder.mutation({
          query: (cartId) => ({
            url: '/orderHead-management/managed-orderHead/get-cart',  
            method: 'PUT',
            body: cartId
          }),
        }),  
        
        AddToCart: builder.mutation({
          query: (cartItemDetails) => ({
            url: '/orderDet-management/managed-orderDet/guest',
            method: 'POST',
            body: cartItemDetails
          }),
          // 'restaurantTickets' so the floor plan picks up the new unsent item.
          invalidatesTags: ['cart', 'table', 'restaurantTickets']
        }),
    
        updateCartQuantity: builder.mutation({
          query: (cartQty) => ({
            url: '/orderDet-management/managed-orderDet',  
            method: 'PUT',
            body: cartQty
          }),
          invalidatesTags: ['cart', 'restaurantTickets']
        }),

        updateItemStatus: builder.mutation({
          query: (statusDetails) => ({
            url: '/orderDet-management/managed-orderDet/item-status',
            method: 'PUT',
            body: statusDetails
          }),
          invalidatesTags: ['cart', 'restaurantTickets']
        }),

        getRestaurantTickets: builder.query({
          query: (payload) => ({
            url: '/res-orderDet-management/server-list',
            method: 'POST',
            body: payload,
          }),
          providesTags: ['restaurantTickets']
        }),
    
        deleteCartItem: builder.mutation({
          query: (OrderDetId) => ({
              url: `/orderDet-management/managed-orderDet/${OrderDetId}`,
              method: 'POST',
          }),
          invalidatesTags: ['cart', 'restaurantTickets']
        }),
    
        AddCoupon: builder.mutation({
          query: (couponDetails) => ({
            url: '/orderHead-management/managed-orderHead/coupon',
            method: 'PUT',
            body: couponDetails
          }),
          invalidatesTags: ['cart']
        }),
      })

});

// Export hooks for usage in functional components  
export const {
    useGetAllCartItemsQuery,
  useLazyGetAllCartItemsQuery,
    useGetCartQuantityQuery,
    useGetCartIdforUserMutation,
    useAddToCartMutation,
    useUpdateCartQuantityMutation,
    useUpdateItemStatusMutation,
    useGetRestaurantTicketsQuery,
    useDeleteCartItemMutation,
    useAddCouponMutation,
    util: { getRunningOperationPromises },
  } = cartService;
  
  // export endpoints for use in SSR
  export const { getAllCartItems } = cartService.endpoints;